import { render, staticRenderFns } from "./manage-game-service-category.vue?vue&type=template&id=e53b29d8&scoped=true&"
import script from "./manage-game-service-category.vue?vue&type=script&lang=js&"
export * from "./manage-game-service-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53b29d8",
  null
  
)

export default component.exports